import { type ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { errorMessage } from '@/shared/api/client';
import { Alert } from '@/shared/ui/Alert';
import { Spinner } from '@/shared/ui/Layout';
import { isExplicitLogout, useMe } from '@/features/auth/api';

function Centered({ children }: { readonly children: ReactNode }) {
  return <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 16 }}>{children}</div>;
}

export function RequireAuth() {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) {
    return (
      <Centered>
        <Spinner />
      </Centered>
    );
  }
  if (me.isError) {
    return (
      <Centered>
        <Alert kind="error">{errorMessage(me.error)}</Alert>
      </Centered>
    );
  }
  if (me.data === null) {
    return <Navigate to="/login" replace state={isExplicitLogout() ? null : { from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
